import React from "react";
import { useTranslation } from "react-i18next";
import CodeScanFindingCard from "./CodeScanFindingCard";

const SEVERITY_ORDER = ["ERROR", "WARNING", "INFO"];

const severityLabels = {
    ERROR: "Errors",
    WARNING: "Warnings",
    INFO: "Info",
};

function CodeScanFindingsList({ findings, onUpdateStatus }) {
    const { t } = useTranslation();

    if (!findings || findings.length === 0) {
        return (
            <div className="text-center py-8 text-sm text-gray-500">
                {t("appPreview.noFindings") || "No findings to display"}
            </div>
        );
    }

    const grouped = React.useMemo(() => {
        const groups = {};
        for (const severity of SEVERITY_ORDER) {
            const items = findings.filter((f) => f.severity === severity);
            if (items.length > 0) groups[severity] = items;
        }
        return groups;
    }, [findings]);

    return (
        <div className="p-4 space-y-4">
            {SEVERITY_ORDER.map((severity) => {
                const items = grouped[severity];
                if (!items) return null;
                return (
                    <div key={severity}>
                        <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            {t(`appPreview.${severity.toLowerCase()}s`) ||
                                severityLabels[severity]}{" "}
                            ({items.length})
                        </h4>
                        <div className="space-y-2">
                            {items.map((finding) => (
                                <CodeScanFindingCard
                                    key={finding.id}
                                    finding={finding}
                                    onUpdateStatus={onUpdateStatus}
                                />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default React.memo(CodeScanFindingsList);
